import React from "react";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const fmt = (n) => Number(n || 0).toLocaleString("es-VE", { maximumFractionDigits: 1 });

export const PlayerDashboard = ({ dashboard }) => {
  const t = dashboard.totals;
  const tiles = [
    ["Agentes activos", fmt(t.agents)],
    ["Interacciones", fmt(t.chats)],
    ["Horas ahorradas", fmt(t.hours_saved)],
    [`${t.currency || "USD"} ahorrados`, `${t.currency || "USD"} ${fmt(t.usd_saved)}`], // fix 12b: real currency
    ["Tareas completadas", fmt(t.tasks_completed)],
    ["CSAT", `${fmt(t.csat_pct)}%`],
  ];
  return (
    <section data-testid="player-step-dashboard">
      <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500">Todos los agentes · últimos 6 meses</p>
      <div className="mt-4 grid grid-cols-2 gap-px bg-slate-200 md:grid-cols-3 lg:grid-cols-6" data-testid="player-dashboard-tiles">
        {tiles.map(([k, v]) => (
          <div key={k} className="bg-white p-5">
            <p className="font-display text-2xl font-semibold text-slate-900">{v}</p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.18em] text-slate-500">{k}</p>
          </div>
        ))}
      </div>
      <div className="mt-6 grid gap-6 lg:grid-cols-3">
        <div className="h-64 border border-slate-200 bg-white p-4 lg:col-span-2">
          <p className="mb-2 text-[10px] uppercase tracking-[0.18em] text-slate-500">Interacciones por mes</p>
          <ResponsiveContainer width="100%" height="90%" initialDimension={{ width: 320, height: 200 }}>
            <BarChart data={dashboard.trend}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="month" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip />
              <Bar dataKey="chats" fill="#4F6BFF" name="Interacciones" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="border border-slate-200 bg-white p-4" data-testid="player-dashboard-agents">
          <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Ahorro por agente</p>
          <ul className="mt-3 space-y-3">
            {dashboard.agents.map((a) => (
              <li key={a.name} className="text-sm">
                <div className="flex justify-between gap-3">
                  <span className="text-slate-700">{a.name}</span>
                  <span className="font-semibold text-slate-900">{a.currency || "USD"} {fmt(a.usd_saved)}</span>
                </div>
                <p className="text-[10px] uppercase tracking-[0.14em] text-slate-400">
                  {fmt(a.chats)} interacciones · {fmt(a.hours_saved)} h
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
